import { BaseModalComponent } from './../base/base-modal.component';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'inc-professional-data',
  templateUrl: './professional-data.component.html'
})
export class ProfessionalDataComponent extends BaseModalComponent implements OnInit {
  title = 'PROFESSIONAL_DATA';

  constructor(modalController: ModalController) {
    super(modalController);
    this.reset(new FormGroup({
      identifier: new FormArray([
        new FormGroup({
          value: new FormControl(null, Validators.pattern('^[0-9]{5}(\/[0-9]{1,})?'))
        })
      ]),
      issuer: new FormGroup({
        reference: new FormControl(null, Validators.pattern('^[0-9]{9}$'))
      })
    }));
  }

  save() {
    this.baseSave({ value: { qualification: this.form } });
  }
}
